<template>
  <div class="card-event-date">
    <div class="card-event-date__month">
      <span>{{ month }}</span>
    </div>
    <div class="card-event-date__day">
      <span>{{ day }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardEventDate',
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      month: '',
      day: ''
    }
  },
  created () {
    this.splitDate()
  },
  methods: {
    splitDate () {
      const splittedDate = this.date.split('/')
      this.day = splittedDate[0]
      this.month = this.getMonth(splittedDate[1])
    },
    getMonth (string) {
      const locale = this.$i18n.locale
      const index = Number(string) - 1
      const months = [ ...this.$i18n.messages[locale].message.months ]
      return months[index].abbr
    }
  }
}
</script>

<style lang="scss">
  .card-event-date{
    @media print {
      border: 1px solid black;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    .card-event--small &{
      @include size(5rem);
    }

    .card-event--medium &,
    .card-event--large &,
    .card-event--groups &{
      @include size(7rem);
    }

    &__month{
      @media print {
        background-color: black;
      }
      width: 100%;
      flex: 0 1 auto;
      background-color: colors("error");
      font-size: 1.2rem;
      font-weight: font-weights("bold");
      color: white;
    }

    &__day{
      width: 100%;
      flex: 1 1 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      font-weight: font-weights("normal");
      line-height: 1;

      .card-event--small &{
        font-size: 2.8rem;
      }

      .card-event--medium &,
      .card-event--large &,
      .card-event--groups &{
        font-size: 4rem;
      }

      span{
        flex: 0 1 auto;
      }
    }
  }
</style>
